/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.FieldLabels {
    angular.module("meevo.plugins.fieldLabels", []);
}